import React from 'react';
import PageShell from './PageShell';
import Breadcrumbs from '../Breadcrumbs';
import Team from '../sections/Team';
import History from '../sections/History';
import About from '../sections/About';
import MidCTA from '../sections/MidCTA';
import { usePageMeta } from '../../lib/useMeta';

const PATH = '/about';

const BREADCRUMBS = [
  { label: 'Home', href: '/' },
  { label: 'About the School' },
];

const AboutPage = () => {
  usePageMeta({
    title: 'About Universal Kempo Karate | Colorado Springs Karate School Since 1980',
    description:
      'Universal Kempo Karate is a family-owned, veteran-founded karate school in Colorado Springs. Meet our instructors and learn how we have trained local families since 1980.',
    path: PATH,
    breadcrumbs: BREADCRUMBS,
  });
  return (
    <PageShell>
      <Breadcrumbs items={BREADCRUMBS} />
      <div className="max-w-7xl mx-auto px-4 sm:px-6 pt-6 pb-4">
        <h1 className="font-display font-black tracking-tight text-white text-[2rem] leading-[1.05] sm:text-5xl sm:leading-[1.02]">
          About Universal Kempo Karate
        </h1>
        <p className="mt-4 text-white/75 text-[15px] sm:text-lg leading-relaxed max-w-3xl">
          A family-owned, veteran-founded Colorado Springs karate school that has trained
          generations of local families since 1980. Meet the instructors, learn the lineage,
          and see why so many of our students stay for life.
        </p>
      </div>
      <About />
      <Team />
      <History />
      <MidCTA />
    </PageShell>
  );
};

export default AboutPage;
